/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccessTokenError } from '../model/accessTokenError';
import { ErrorMessage } from '../model/errorMessage';
import { RequestInfo10 } from '../model/requestInfo10';
import { RequestInfo11 } from '../model/requestInfo11';
import { RequestInfo7 } from '../model/requestInfo7';
import { RequestInfo8 } from '../model/requestInfo8';
import { RequestInfo9 } from '../model/requestInfo9';
import { ResponseInfo10 } from '../model/responseInfo10';
import { ResponseInfo11 } from '../model/responseInfo11';
import { ResponseInfo12 } from '../model/responseInfo12';
import { ResponseInfo8 } from '../model/responseInfo8';
import { ResponseInfo9 } from '../model/responseInfo9';
import { ResponseInfoList } from '../model/responseInfoList';
import { ResponseInfoList2 } from '../model/responseInfoList2';
import { RetrieveAllResponseInfoList } from '../model/retrieveAllResponseInfoList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ProcessMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * OrgMgr_ProcessMgr_RetrieveProcessExecutionLog, Retrieve the ProcessExecutionLog
     * Retrieve the ProcessExecutionLog
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrProcessMgrV1ProcessExecutionLogPost(Request: RequestInfo10, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo11>;
    public orgMgrProcessMgrV1ProcessExecutionLogPost(Request: RequestInfo10, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo11>>;
    public orgMgrProcessMgrV1ProcessExecutionLogPost(Request: RequestInfo10, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo11>>;
    public orgMgrProcessMgrV1ProcessExecutionLogPost(Request: RequestInfo10, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrProcessMgrV1ProcessExecutionLogPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ResponseInfo11>(`${this.basePath}/OrgMgr/ProcessMgr/V1/ProcessExecutionLog`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ProcessMgr_RetrieveProcessExecution, Retrieve the ProcessExecution
     * Retrieve the ProcessExecution
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrProcessMgrV1ProcessExecutionPost(Request: RequestInfo9, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo10>;
    public orgMgrProcessMgrV1ProcessExecutionPost(Request: RequestInfo9, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo10>>;
    public orgMgrProcessMgrV1ProcessExecutionPost(Request: RequestInfo9, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo10>>;
    public orgMgrProcessMgrV1ProcessExecutionPost(Request: RequestInfo9, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrProcessMgrV1ProcessExecutionPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ResponseInfo10>(`${this.basePath}/OrgMgr/ProcessMgr/V1/ProcessExecution`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ProcessMgr_RetrieveAllProcess, Retrieve all process
     * Retrieve all process
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrProcessMgrV1ProcessGet(observe?: 'body', reportProgress?: boolean): Observable<ResponseInfoList>;
    public orgMgrProcessMgrV1ProcessGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfoList>>;
    public orgMgrProcessMgrV1ProcessGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfoList>>;
    public orgMgrProcessMgrV1ProcessGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseInfoList>(`${this.basePath}/OrgMgr/ProcessMgr/V1/Process`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ProcessMgr_RetrieveAllProcessInstance, RetrieveAll ProcessInstances
     * Retrieve the ProcessInstance by Id
     * @param Level Enter the Level
     * @param GroupId Enter the GroupId
     * @param OrgId Enter the OrgId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrProcessMgrV1ProcessInstanceGet(Level: string, GroupId?: string, OrgId?: string, observe?: 'body', reportProgress?: boolean): Observable<RetrieveAllResponseInfoList>;
    public orgMgrProcessMgrV1ProcessInstanceGet(Level: string, GroupId?: string, OrgId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RetrieveAllResponseInfoList>>;
    public orgMgrProcessMgrV1ProcessInstanceGet(Level: string, GroupId?: string, OrgId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RetrieveAllResponseInfoList>>;
    public orgMgrProcessMgrV1ProcessInstanceGet(Level: string, GroupId?: string, OrgId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Level === null || Level === undefined) {
            throw new Error('Required parameter Level was null or undefined when calling orgMgrProcessMgrV1ProcessInstanceGet.');
        }

        let headers = this.defaultHeaders;
        if (Level !== undefined && Level !== null) {
            headers = headers.set('Level', String(Level));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<RetrieveAllResponseInfoList>(`${this.basePath}/OrgMgr/ProcessMgr/V1/ProcessInstance`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ProcessMgr_RetrieveProcessInstanceHistory, Retrieve ProcessInstance History
     * Retrieve ProcessInstance History
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrProcessMgrV1ProcessInstanceHistoryPost(Request: RequestInfo11, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo12>;
    public orgMgrProcessMgrV1ProcessInstanceHistoryPost(Request: RequestInfo11, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo12>>;
    public orgMgrProcessMgrV1ProcessInstanceHistoryPost(Request: RequestInfo11, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo12>>;
    public orgMgrProcessMgrV1ProcessInstanceHistoryPost(Request: RequestInfo11, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrProcessMgrV1ProcessInstanceHistoryPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ResponseInfo12>(`${this.basePath}/OrgMgr/ProcessMgr/V1/ProcessInstanceHistory`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ProcessMgr_DeleteProcessInstance, Delete the requested ProcessInstance
     * Delete the requested ProcessInstance
     * @param Id Enter the processInstance id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrProcessMgrV1ProcessInstanceIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrProcessMgrV1ProcessInstanceIdDelete(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public orgMgrProcessMgrV1ProcessInstanceIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public orgMgrProcessMgrV1ProcessInstanceIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrProcessMgrV1ProcessInstanceIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/ProcessMgr/V1/ProcessInstance/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ProcessMgr_RetrieveProcessInstance, Retrieve the ProcessInstance by Id
     * Retrieve the ProcessInstance by Id
     * @param Id Enter the Id for which ProcessInstance needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrProcessMgrV1ProcessInstanceIdGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfoList2>;
    public orgMgrProcessMgrV1ProcessInstanceIdGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfoList2>>;
    public orgMgrProcessMgrV1ProcessInstanceIdGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfoList2>>;
    public orgMgrProcessMgrV1ProcessInstanceIdGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrProcessMgrV1ProcessInstanceIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseInfoList2>(`${this.basePath}/OrgMgr/ProcessMgr/V1/ProcessInstance/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ProcessMgr_UpdateProcessInstance, Update a ProcessInstance
     * Update a ProcessInstance
     * @param Id Enter the Id for which ProcessInstance needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrProcessMgrV1ProcessInstanceIdPatch(Id: number, Request: RequestInfo8, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo9>;
    public orgMgrProcessMgrV1ProcessInstanceIdPatch(Id: number, Request: RequestInfo8, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo9>>;
    public orgMgrProcessMgrV1ProcessInstanceIdPatch(Id: number, Request: RequestInfo8, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo9>>;
    public orgMgrProcessMgrV1ProcessInstanceIdPatch(Id: number, Request: RequestInfo8, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrProcessMgrV1ProcessInstanceIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrProcessMgrV1ProcessInstanceIdPatch.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.patch<ResponseInfo9>(`${this.basePath}/OrgMgr/ProcessMgr/V1/ProcessInstance/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ProcessMgr_CreateProcessInstance, Create a ProcessInstance
     * Create a ProcessInstance
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrProcessMgrV1ProcessInstancePost(Request: RequestInfo7, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo8>;
    public orgMgrProcessMgrV1ProcessInstancePost(Request: RequestInfo7, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo8>>;
    public orgMgrProcessMgrV1ProcessInstancePost(Request: RequestInfo7, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo8>>;
    public orgMgrProcessMgrV1ProcessInstancePost(Request: RequestInfo7, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrProcessMgrV1ProcessInstancePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ResponseInfo8>(`${this.basePath}/OrgMgr/ProcessMgr/V1/ProcessInstance`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
